import { useSelector } from "react-redux";
import { Navigate, useParams } from "react-router";

import { selectCurrentAccount } from "fond/api";
import { ACCOUNT_KEY, SEARCH_KEY } from "fond/constants";
import SearchResults from "fond/projects/GlobalSearch/SearchResults";
import { Navigation } from "fond/projects/Navigation";
import { useQueryParams } from "fond/utils/hooks";
import { PageContent } from "fond/widgets";

import SharedContentList from "./SharedContentList";

const SharedWithMe: React.FC = () => {
  const searchQuery = useQueryParams(SEARCH_KEY);
  const legacySelectedAccount = useQueryParams(ACCOUNT_KEY) || "";
  const currentAccountId = useSelector(selectCurrentAccount)?.ID;
  const { account: selectedAccount } = useParams();

  // If the account is passed as a query param, redirect to the new URL format
  if (legacySelectedAccount) {
    return <Navigate to={`/shared/${legacySelectedAccount}`} replace />;
  }

  const subTitle = selectedAccount && `by ${selectedAccount === currentAccountId ? "team members" : "other users"}`;

  return searchQuery ? (
    <SearchResults />
  ) : (
    <PageContent
      windowTitle={`Shared with me ${subTitle}`}
      title="Shared with me"
      subTitle={subTitle?.toUpperCase()}
      mainContent={<SharedContentList />}
      testId="filter-shared"
      navigation={<Navigation />}
    />
  );
};

export default SharedWithMe;
